import type { TypedThunk } from 'src/store'
import { fetchBrandConfig } from 'utils/fetchBrandConfig'

import { actions } from './slice'

export const { saveBrandConfig } = actions

export const getBrandConfig = (): TypedThunk => async (dispatch) => {
  const brandConfig = await fetchBrandConfig()

  if (brandConfig) {
    dispatch(saveBrandConfig(brandConfig))
  }
}
